module.exports = __webpack_public_path__ + "img/m4a.cc2802a1.svg";